import {EXCHANGES_URL} from '../../../@crema/services/ApiConfig';
import {Action, Dispatch} from 'redux';
import {
  ExchangesActionTypes,
  FETCH_EXCHANGES_DATA,
  FETCH_EXCHANGES_DATA_ERROR,
  FETCH_EXCHANGES_DATA_SUCCESS,
  UPDATE_EXCHANGES_DATA,
} from '../../../types/actions/Exchanges/Exchanges.action';
import {ApiActionTypes, ApiActionCall} from '../Api';
import {IExchange} from '../../../types/models/Exchange';
import {showError} from '../Common';
import {logger} from '../../../shared/logger';
import {
  ADD_EVENT_SOURCE,
  AddEventSource,
  REMOVE_EVENT_SOURCE,
  RemoveEventSource,
} from '../../../types/actions/EventSource.actions';
import {getExchangesData} from '../../selectors';
import {AppState} from '../../store';

export const fetchExchanges = () => async (
  dispatch: Dispatch<ApiActionCall | ExchangesActionTypes | AddEventSource>,
) => {
  dispatch({type: FETCH_EXCHANGES_DATA});

  const onSuccess = (payload: IExchange[]) => {
    const data = Array.isArray(payload) ? payload : [];
    if (data.length > 0) {
      watchExchangesLive(data)(dispatch);
    }
    return {
      type: FETCH_EXCHANGES_DATA_SUCCESS,
      payload: data,
    };
  };
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_EXCHANGES_DATA_ERROR});
    dispatch(showError('Failed to fetch Exchange data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: EXCHANGES_URL,
      method: 'GET',
      label: 'Fetch Exchange data',
      onSuccess,
      onFailure,
    },
  });
};

export const watchExchangesLive = (exchanges: IExchange[]) => (
  dispatch: Dispatch<AddEventSource | ExchangesActionTypes>,
) => {
  exchanges.forEach(({slug}) => {
    dispatch({
      type: ADD_EVENT_SOURCE,
      payload: {
        url: EXCHANGES_URL + '/' + slug + '/reports/live',
        onMessage: (e) => {
          const data: {last: string} = JSON.parse(e.data);
          if (data.last) {
            dispatch({
              type: UPDATE_EXCHANGES_DATA,
              payload: {slug, last: Number(data.last)},
            });
          }
        },
      },
    });
  });
};

export const clearExchangesLive = () => (
  dispatch: Dispatch<RemoveEventSource>,
  getState: () => AppState,
) => {
  getExchangesData(getState()).forEach(({slug}) => {
    dispatch({
      type: REMOVE_EVENT_SOURCE,
      payload: EXCHANGES_URL + '/' + slug + '/reports/live',
    });
  });
};
